<template>
  <b-container fluid>
        <b-row>
            <b-col cols="12" md="4">
                <div class="login__description">
                    <div>
                        <h3>
                            <img :src="$cdn + '/icons/icon-person-login.svg'" alt="icono persona">
                            Recuperar usuario
                        </h3>
                        <p>Te enviaremos un email para que puedas recuperar tu usuario y acceso.</p>
                    </div>
                </div>
            </b-col>
            <b-col cols="12" md="4">
                <div class="login__form">
                    <div class="login__paragraph">
                        <p>Completa la siguiente información:</p>
                    </div>
                    <div class="labels">
                        <label for="emailRecovery">Email</label>
                    </div>
                    <div class="inputs mb-5">
                        <input v-model="emailRecovery" id="emailRecovery" placeholder="Ingrese su email" type="text">
                    </div>
                    <button class="button-principal" @click="recuperarClave">Solicitar recuperación</button>
                </div>
            </b-col>
            <b-col>
                <div class="login__logo">
                    <img :src="$cdn + '/logos/logo-Cajasan-azul-slogan.png'" alt="Logo Cajasan">
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
export default {
  name: 'formRecovery',
  data () {
    return {
      emailRecovery: ''
    }
  },
  methods: {
    recuperarClave: function () {
      if(this.emailRecovery != ''){
        let datos = {
          email: this.emailRecovery
        }
        this.$store.dispatch('recuperarClave', datos).then(responde => {
          this.$swal("Email enviado")
          this.$router.push('/')
        })
      }
    }
  }
}
</script>
